export default class LiveWseViewModel {
    public wseId: string = '';
    public revisionNumber: string = '';
    public aimsStatus: string = '';
    public approvalDate: Date = new Date();
    public status: string = '';
    public draftedById: string = '';
    public workingRevisionId: number = 0;
    public canStartNewWse: boolean = false;
}
